(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('parameters.config', {
            parent: 'parameters',
            url: '/parametres',
            title: 'Configurations',
            sidebarMeta: {
                icon: 'glyphicon glyphicon-settings',
                order: 15
            },
            data: {
                authorities: ['ROLE_ADMIN','ROLE_RESPONSABLE'],
                pageTitle: 'josdaviApp.parametre.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/parametre/parametres.html',
                    controller: 'ParametreController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });    }

})();
